import { useCallback, useEffect } from 'react'

import { isNativeApp, postMessageToApp } from '@/shared/lib/app-bridge'

export { isAndroid, isIos } from '@/shared/lib/app-bridge'

export const useAppNavbar = (
    title: null | string = null,
    leftButtonTitle: null | string = null,
    leftButtonAction: null | string = null,
): void => {
    const setupNavbar = useCallback(
        (navTitle: string, navLeftButtonTitle?: string, navLeftButtonAction?: string) => {
            const message = {
                action: 'setup_navigation_bar' as const,
                data: {
                    title: navTitle,
                    left_button_title: navLeftButtonTitle,
                    left_button_action: navLeftButtonAction,
                },
            }

            postMessageToApp(message)
        },
        [],
    )

    useEffect(() => {
        if (title && isNativeApp()) {
            if (leftButtonTitle && leftButtonAction) {
                setupNavbar(title, leftButtonTitle, leftButtonAction)
            } else {
                setupNavbar(title)
            }
        }
    }, [title, leftButtonTitle, leftButtonAction, setupNavbar])
}
